import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";

export default function ScheduleShipmentAnalysisGrid(props) {
  const [summaryData, setSummaryData] = useState();

  useEffect(() => {
    if (summaryData !== props.summaryData) {
      setSummaryData(props.summaryData);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.summaryData]);

  return (
    <>
      New Orders
      <Table size="sm" className="data-table">
        <thead className="table-header">
          <tr>
            <th>Day Of Week</th>
            <th style={{ textAlign: "center" }}>Monday</th>
            <th style={{ textAlign: "center" }}>Tuesday</th>
            <th style={{ textAlign: "center" }}>Wednesday</th>
            <th style={{ textAlign: "center" }}>Thursday</th>
            <th style={{ textAlign: "center" }}>Friday</th>
            <th style={{ textAlign: "center" }}>Totals</th>
          </tr>
        </thead>
        <tbody>
          {_.map(summaryData, (datum, index) => {
            return (
              <tr
                key={index}
                className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
              >
                <td className="data-cell" children={datum.rowDesc} />
                <td
                  style={{ textAlign: "center" }}
                  className="data-cell"
                  children={datum.formattedMondayVal}
                />
                <td
                  style={{ textAlign: "center" }}
                  className="data-cell"
                  children={datum.formattedTuesdayVal}
                />
                <td
                  style={{ textAlign: "center" }}
                  className="data-cell"
                  children={datum.formattedWednesdayVal}
                />
                <td
                  style={{ textAlign: "center" }}
                  className="data-cell"
                  children={datum.formattedThursdayVal}
                />
                <td
                  style={{ textAlign: "center" }}
                  className="data-cell"
                  children={datum.formattedFridayVal}
                />
                <td
                  style={{ textAlign: "center" }}
                  className="data-cell"
                  children={datum.formattedTotalVal}
                />
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}
